import { Popconfirm, Space, type DescriptionsProps } from "antd";
import { Link } from "react-router-dom";
import { AppointmentTimeSlotPlan } from "@rumble-it/common-lib/types/models/AppointmentTimeSlotPlan.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Descriptions } from "@/components/v2";
import { Button, Card } from "@rumbledirect/ui";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

interface AppointmentTimeSlotPlanDetailCardProps {
  appointmentTimeSlotPlan: AppointmentTimeSlotPlan | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const AppointmentTimeSlotPlanDetailCard = ({
  appointmentTimeSlotPlan,
  isLoading,
  deleteMutation,
}: AppointmentTimeSlotPlanDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Naam",
      children: appointmentTimeSlotPlan?.name,
    },
    {
      label: "Beschrijving",
      children: appointmentTimeSlotPlan?.description || "-",
    },
    {
      label: "Opdrachtgever",
      children: appointmentTimeSlotPlan?.company
        ? appointmentTimeSlotPlan.company.fullName
        : "-",
    },
    {
      label: "Dealer",
      children: appointmentTimeSlotPlan?.dealership
        ? appointmentTimeSlotPlan.dealership.fullName
        : "-",
    },
    {
      label: "Aantal werkdagen voor start planning",
      children: appointmentTimeSlotPlan?.minimumStartWorkingDays,
    },
    {
      label: "Aantal maanden voor einde planning",
      children: appointmentTimeSlotPlan?.maximumEndMonths,
    },
    {
      label: "Feestdagen configuratie",
      children: appointmentTimeSlotPlan?.holidayConfig?.label || "-",
    },
  ];

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Planning"
      extra={
        <Space>
          <Link
            to={`/appointment-time-slots/plans/${appointmentTimeSlotPlan?.id}/edit`}
          >
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Planning verwijderen"
            description="Weet je zeker dat je deze planning wil verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      {/* Using Descriptions to display the Planning details */}
      <Descriptions items={items} />
    </Card>
  );
};
